import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingContainer from "@/components/onboarding/OnboardingContainer/OnboardingContainer.vue";
import {
  OnboardingContainerTypeEnum,
  OnboardingRouteItemNameEnum,
} from "@/types/onboarding";

import { provide, computed } from "vue";
import { onboardingInjectionKey } from "@/utils/onboarding/onboardingInjectionKey";
import { ButtonObject } from "@/types/button";
import { handleOnboardingContinue } from "@/utils/settings";


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingWelcome',
  setup(__props) {

provide(onboardingInjectionKey, {
  type: OnboardingContainerTypeEnum.Onboarding,
  routeName: OnboardingRouteItemNameEnum.Welcome,
});

const primaryButton = computed<ButtonObject>(() => {
  return {
    handleClick: handleContinue,
    text: "onboarding.welcome.continue",
  };
});

const handleContinue = () => {
  handleOnboardingContinue(OnboardingRouteItemNameEnum.Welcome);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingContainer, {
    title: "onboarding.welcome.title",
    text: "onboarding.welcome.text",
    "primary-button": primaryButton.value,
    "image-name": "welcome.jpg",
    "component-name": "welcome"
  }, null, 8, ["primary-button"]))
}
}

})